class TabPanel extends HTMLElement {
  constructor() {
    super();

    this.tabButtonsContainer = this.querySelector('.tab-buttons-container');
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');

    this.dropdown = this.querySelector('.tab-dropdown__select');

    if (this.dropdown) {
      this.dropdown.addEventListener('change', this.onChangeHandler.bind(this));
    }

    this.initTabs();
  }

  onChangeHandler(e) {
    const value = e.target.value;

    this.tabs.forEach((tab) => {
      if (tab.getAttribute('id') === value) {
        this.selectTab(tab);
      }
    });
  }

  initTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab));
      tab.addEventListener('pointerdown', () => this.selectTab(tab));
    });
  }

  selectTab(selectedTab) {
    this.panels.forEach((panel) => (panel.style.display = 'none'));
    this.tabs.forEach((tab) => tab.setAttribute('aria-selected', 'false'));

    const panel = this.querySelector(`#${selectedTab.getAttribute('aria-controls')}`);
    panel.style.display = 'block';
    selectedTab.setAttribute('aria-selected', 'true');
  }
}

customElements.define('tab-panel', TabPanel);
